export function SkeletonRow() {
  return (
    <section className="media-section" aria-label="Loading content">
      <div className="skeleton-title shimmer" />
      <div className="media-row">
        {Array.from({ length: 6 }).map((_, index) => (
          <div className="skeleton-card shimmer" key={index} />
        ))}
      </div>
    </section>
  )
}
